export const environment = {
  production: true,
  apiServer: 'https://api.didgigo.com/v1',
  apiKey: 'DD3276A7-01B4-466E-8B50-E20B1068FF80',
  ingestionServer: 'https://ingestion.didgigo.com',
  applicationInsightsKey: 'cd716023-7fb0-46a8-9fb3-3df4f97c9c42'
};
